"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInfoDialogController = void 0;
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _presentationHooks = require("@ori/presentation-hooks");
var _presentationHttp = require("@ori/presentation-http");
var _presentationProductDetail = require("@ori/presentation-product-detail");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _constants = require("../constants");
var _constantsGenerated = require("../constants-generated");
var _hooks = require("../hooks");
var _internal = require("../hooks/internal");
var _logger2 = require("../logger");
var _ApiProvider = require("./ApiProvider");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore file @preserve -- no need to test controller

const localLogger = _logger2.mainLogger.createChild('TranslatedController');
const onError = error => localLogger.error(new Error('TranslationsProvider fetching failed', {
  cause: error
}));
const TranslatedController = ({
  open,
  onClose,
  onOpen
}) => {
  const {
    initialProductCode,
    lineNumber,
    mode,
    originalItemCode,
    originalQuantity,
    placement,
    position,
    productCodes,
    replaceSubscription
  } = (0, _internal.useOpenEvent)({
    onOpen
  });
  const {
    closeProductInfoDialog,
    openProductInfoDialog,
    productInfoDialog
  } = (0, _hooks.useProductInfoDialog)({
    analytics: {
      lineNumber,
      position,
      placement
    },
    dialog: {
      onClose
    },
    initialProductCode,
    mode,
    productCodes,
    shared: {
      originalItemCode,
      originalQuantity
    },
    replaceSubscription
  });
  (0, _internal.useCloseEvents)({
    onClose
  });
  (0, _react.useEffect)(() => {
    if (open) {
      openProductInfoDialog();
    } else {
      closeProductInfoDialog();
    }
  }, [closeProductInfoDialog, open, openProductInfoDialog]);
  return productInfoDialog;
};
const ProductInfoDialogController = ({
  translations
}) => {
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    customerId,
    token
  } = (0, _auth.useToken)();
  const {
    initialOpenDone,
    open,
    onClose,
    onOpen
  } = (0, _presentationHooks.useInitialDisclose)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
    team: _testidGenerator.Team.Presentation,
    project: _constantsGenerated.APP_NAME,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: null,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
        logger: _logger2.mainLogger,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
          areaName: "ProductInfoDialogController",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
            clientFetchConfiguration: initialOpenDone ? {
              baseUrl: staticApiUrl,
              onError,
              tenant
            } : undefined,
            defaultTranslationsWithNamespaces: {
              [_constants.translationsNamespace]: _constants.defaultTranslations,
              [_presentationProductDetail.presentationProductDetailTranslationsNamespace]: _presentationProductDetail.presentationProductDetailDefaultTranslations
            },
            language: language,
            translationsWithNamespaces: translations,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
              namespace: _constants.translationsNamespace,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationHttp.UserSegmentationDataProvider, {
                  disableFetching: !initialOpenDone,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationHttp.HeadersProvider, {
                    customerId: customerId,
                    language: language,
                    sourceAppName: _constantsGenerated.PACKAGE_NAME,
                    tenant: tenant,
                    token: token,
                    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(TranslatedController, {
                      open: open,
                      onClose: onClose,
                      onOpen: onOpen
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
exports.ProductInfoDialogController = ProductInfoDialogController;